"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1241],{

/***/ 68137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ParagraphAndAssetComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/arrays.js
var arrays = __webpack_require__(84657);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
// EXTERNAL MODULE: ./services/paragraph-service.js
var paragraph_service = __webpack_require__(54943);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component.scss.js


var StyledParagraphAndAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14y19jy0"
})("display:flex;flex-direction:column;.top-line{flex:1 0 auto;display:flex;justify-content:space-between;.content-column{max-width:45%;display:flex;align-items:center;justify-content:center;.signup-wrapper{margin-top:16px;}}.asset-column{max-width:50%;display:flex;align-items:center;justify-content:center;position:relative;}}&.asset-left{.top-line{flex-direction:row-reverse;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:auto;.top-line{flex-direction:column;flex-wrap:wrap;align-items:center;.content-column{flex:0 0 100%;margin-bottom:48px;max-width:100%;}.asset-column{flex:0 0 100%;max-width:100%;}}}");
var StyledContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14y19jy1"
})("div{font-size:0.875rem;font-weight:300;line-height:1.6;margin-bottom:16px;}");

;// CONCATENATED MODULE: ./components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var ParagraphAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ParagraphAndAssetComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ParagraphAndAssetComponent);
    function ParagraphAndAssetComponent() {
        (0,_class_call_check/* default */.Z)(this, ParagraphAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ParagraphAndAssetComponent, [
        {
            key: "renderParagraphs",
            value: function renderParagraphs(paragraphs) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                    className: "content-body",
                    children: paragraphs.map(function(paragraph, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: paragraph
                            }
                        }, index);
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, content = _props.content, asset = _props.asset, columnWidth = _props.columnWidth, imageWidth = _props.imageWidth;
                var contentBody = content.body;
                contentBody = (0,arrays.convertToArrayIfNeeded)(contentBody);
                var withContent = !(0,paragraph_service/* isContentEmpty */._)(content);
                var withAsset = asset.image || asset.video;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledParagraphAndAssetComponent, {
                    className: classnames_default()("paragaph-and-asset-columns", {
                        "asset-left": asset.side == "left"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-line",
                        style: {
                            width: columnWidth
                        },
                        children: [
                            withContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "content-column",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, _object_spread({}, content))
                            }),
                            withAsset && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "asset-column",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, asset), {
                                    width: imageWidth
                                }))
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ParagraphAndAssetComponent;
}(react.PureComponent);

ParagraphAndAssetComponent.defaultProps = {
    content: {},
    asset: {}
};


/***/ }),

/***/ 1241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ basic_segments; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
;// CONCATENATED MODULE: ./components/segments/paragraph/paragraph-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var ParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ParagraphComponent);
    function ParagraphComponent() {
        (0,_class_call_check/* default */.Z)(this, ParagraphComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ParagraphComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, _object_spread({}, this.props));
            }
        }
    ]);
    return ParagraphComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/segments/simple-colorful-title-with-signup/simple-colorful-title-with-signup-component.js + 1 modules
var simple_colorful_title_with_signup_component = __webpack_require__(94456);
// EXTERNAL MODULE: ./components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component.js + 1 modules
var paragraph_and_asset_columns_component = __webpack_require__(68137);
// EXTERNAL MODULE: ./components/core/stars/stars-component.js + 1 modules
var stars_component = __webpack_require__(763);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/customer-success/customer-success-component.scss.js


var StyledCustomerSuccessComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qn8xvr0"
})("display:flex;flex-wrap:wrap;justify-content:space-around;.paragaph-and-asset-columns .top-line{box-sizing:content-box;flex-direction:column-reverse;justify-content:flex-end !important;.paragraph-component .title .colorful-title{font-size:1.375rem;.colored{font-size:1.375rem;}}.asset-column{margin-bottom:32px;}.content-column,.asset-column{max-width:100% !important;}.asset-inner{img{width:100%;height:100%;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.paragaph-and-asset-columns{width:100%;height:100%;text-align:center;.top-line{text-align:center;margin:32px auto;width:100% !important;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){flex-direction:column;div.paragaph-and-asset-columns div.top-line{flex-direction:column-reverse !important;}}");

;// CONCATENATED MODULE: ./components/segments/customer-success/customer-success-component.js




function customer_success_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function customer_success_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            customer_success_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var CustomerSuccessComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CustomerSuccessComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CustomerSuccessComponent);
    function CustomerSuccessComponent() {
        (0,_class_call_check/* default */.Z)(this, CustomerSuccessComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CustomerSuccessComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, columnWidth = _props.columnWidth, imageWidth = _props.imageWidth;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCustomerSuccessComponent, {
                    className: "customer-success-component",
                    children: this.props.assets.map(function(assetAndParagaph, index) {
                        var stars = assetAndParagaph.stars;
                        var showStars = (stars || {}).showStars;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "customer-success-item-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_and_asset_columns_component/* default */.Z, _object_spread_props(customer_success_component_object_spread({}, assetAndParagaph), {
                                    columnWidth: columnWidth,
                                    imageWidth: imageWidth
                                })),
                                showStars && /*#__PURE__*/ (0,jsx_runtime.jsx)(stars_component/* default */.Z, customer_success_component_object_spread({}, stars))
                            ]
                        }, index);
                    })
                });
            }
        }
    ]);
    return CustomerSuccessComponent;
}(react.PureComponent);

CustomerSuccessComponent.defaultProps = {
    columnWidth: "240px",
    imageWidth: "200px",
    assets: [
        {
            asset: {
                shadow: false,
                image: {
                    src: "/static/img/customer-success/tan.png",
                    alt: "Webinars"
                }
            },
            content: {
                title: "Webinars",
                textDirection: "center",
                body: [
                    "On-demand or live, get in-depth knowledge on a variety of topics"
                ],
                bottomLink: {
                    text: "Attend a webinar",
                    href: "/webinars"
                }
            }
        },
        {
            asset: {
                shadow: false,
                image: {
                    src: "/static/img/customer-success/shira.png",
                    alt: "Articles"
                }
            },
            content: {
                title: "Articles",
                textDirection: "center",
                body: [
                    "If words are more your thing, read up on all things why, how and what"
                ],
                bottomLink: {
                    text: "Read an article",
                    href: "/support"
                }
            }
        },
        {
            asset: {
                shadow: false,
                image: {
                    src: "/static/img/customer-success/omri.png",
                    alt: "Tutorials"
                }
            },
            content: {
                title: "Tutorials",
                textDirection: "center",
                body: [
                    "Funny and functional, our tutorials will take you through every process step-by-step"
                ],
                bottomLink: {
                    text: "Watch a tutorial",
                    href: "/guides"
                }
            }
        }
    ]
};

// EXTERNAL MODULE: ./components/core/paragraph-with-logos/paragraph-with-logos-component.js + 1 modules
var paragraph_with_logos_component = __webpack_require__(42832);
;// CONCATENATED MODULE: ./components/segments/security-and-privacy/security-and-privacy-component.scss.js


var StyledSecurityAndPrivacyComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "em9c10f0"
})(".image-gallery{padding:24px;.social-proof-gallery-picture{img{height:148px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.images-gallery-row{.image-gallery{padding:4px;.social-proof-gallery-picture{img{height:50px;}}}}}");

;// CONCATENATED MODULE: ./components/segments/security-and-privacy/security-and-privacy-component.js




function security_and_privacy_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function security_and_privacy_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            security_and_privacy_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var DEFAULT_SECURITY_ASSETS = [
    {
        url: "/static/img/security/gdpr.png",
        alt: "GDPR"
    },
    {
        url: "/static/img/security/iso-27001.png",
        alt: "ISO-27001"
    },
    {
        url: "/static/img/security/iso-27018.png",
        alt: "ISO-27018"
    },
    {
        url: "/static/img/security/soc.png",
        alt: "SOC"
    },
    {
        url: "/static/img/security/hipaa.png",
        alt: "HIPAA"
    }
];
var SecurityAndPrivacyComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SecurityAndPrivacyComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SecurityAndPrivacyComponent);
    function SecurityAndPrivacyComponent() {
        (0,_class_call_check/* default */.Z)(this, SecurityAndPrivacyComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SecurityAndPrivacyComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSecurityAndPrivacyComponent, {
                    className: "security-and-privacy-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "paragraph-with-logos-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_with_logos_component/* default */.Z, security_and_privacy_component_object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return SecurityAndPrivacyComponent;
}(react.PureComponent);

SecurityAndPrivacyComponent.defaultProps = {
    assets: DEFAULT_SECURITY_ASSETS,
    paragraph: {
        textDirection: "center",
        title: "We care about your privacy.",
        body: [
            "As users of our own product, we understand how important the security and privacy of your data is. We are committed to providing our customers with a highly secure and reliable environment for its cloud-based application. We have therefore developed a security model that covers all aspects of cloud-based monday.com systems."
        ]
    }
};

// EXTERNAL MODULE: ./components/segments/text-and-asset/text-and-asset-component.js
var text_and_asset_component = __webpack_require__(31745);
// EXTERNAL MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component.js + 5 modules
var one_pager_with_image_content_component = __webpack_require__(40119);
;// CONCATENATED MODULE: ./components/segments/one-pager-with-image/one-pager-with-image-component.scss.js

var StyledOnePagerWithImageComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wnby4a0"
})(".one-pager-with-image-content-component{.desktop-content-wrapper{max-width:1400px;.desktop-content-component{.text-part-wrapper{width:45%;flex-shrink:0;}.image-wrapper{flex-grow:1;.image-part-wrapper{width:90%;padding:16px 16px;}}}}}");

;// CONCATENATED MODULE: ./components/segments/one-pager-with-image/one-pager-with-image-component.js




function one_pager_with_image_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_with_image_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_with_image_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var OnePagerWithImageComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerWithImageComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerWithImageComponent);
    function OnePagerWithImageComponent(props) {
        (0,_class_call_check/* default */.Z)(this, OnePagerWithImageComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(OnePagerWithImageComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOnePagerWithImageComponent, {
                    className: "one-pager-with-image-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(one_pager_with_image_content_component/* default */.Z, one_pager_with_image_component_object_spread({}, this.props))
                });
            }
        }
    ]);
    return OnePagerWithImageComponent;
}(react.PureComponent);

OnePagerWithImageComponent.defaultProps = {
    imageWithBackgroundPart: {
        backgroundColor: "brand-blue",
        src: "/static/img/boards/board-with-pencils.png",
        alt: "",
        imageSegmentHeight: "100vh"
    },
    textPart: {
        titleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        subtitleLines: [
            "See what everyone on your team is working on in a single glance"
        ],
        bullets: [
            "Manage your projects & tasks with ease",
            "Plan visually on a timeline",
            "Centralize communication in one place"
        ],
        mobileTitleLines: [
            "Project Management",
            "<b>is better when it's visual</b>"
        ],
        mobileSubtitleLines: [
            "See what everyone on your team",
            "is working on in a single glance"
        ],
        color: "black"
    },
    signupForm: {
        buttonColor: "brand-pink",
        buttonText: "Get Started",
        inputPlaceholder: "Enter your work email",
        downloadButtonTitle: "Download The App"
    }
};

// EXTERNAL MODULE: ./components/segments/short-footer/short-footer-component.js
var short_footer_component = __webpack_require__(83234);
// EXTERNAL MODULE: ./components/segments/reviews/reviews-component.js + 3 modules
var reviews_component = __webpack_require__(56333);
// EXTERNAL MODULE: ./components/segments/companies-logos/companies-logos-component.js + 1 modules
var companies_logos_component = __webpack_require__(42307);
;// CONCATENATED MODULE: ./components/segments/basic-segments.js









/* harmony default export */ var basic_segments = ({
    ParagraphComponent: ParagraphComponent,
    SimpleColorfulTitleWithSignupComponent: simple_colorful_title_with_signup_component/* default */.Z,
    CustomerSuccessComponent: CustomerSuccessComponent,
    SecurityAndPrivacyComponent: SecurityAndPrivacyComponent,
    TextAndAssetComponent: text_and_asset_component/* default */.Z,
    OnePagerWithImageComponent: OnePagerWithImageComponent,
    ShortFooterComponent: short_footer_component/* default */.Z,
    ReviewsComponent: reviews_component/* default */.Z,
    CompaniesLogosComponent: companies_logos_component/* default */.Z
});


/***/ }),

/***/ 94456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SimpleColorfulTitleWithSignupComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/simple-colorful-title-with-signup/simple-colorful-title-with-signup-component.scss.js


var StyledSimpleColorfulTitleWithSignupComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eleh1280"
})("text-align:center;.title-wrapper{.colorful-title{font-weight:700;span{font-weight:700;}}}.subtitle-wrapper{margin-top:16px;h2{font-size:1.125rem;}}.signup-form-with-decorations-wrapper{display:flex;justify-content:center;margin-top:24px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){padding-left:24px;padding-right:24px;}");

;// CONCATENATED MODULE: ./components/segments/simple-colorful-title-with-signup/simple-colorful-title-with-signup-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var SimpleColorfulTitleWithSignupComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SimpleColorfulTitleWithSignupComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SimpleColorfulTitleWithSignupComponent);
    function SimpleColorfulTitleWithSignupComponent() {
        (0,_class_call_check/* default */.Z)(this, SimpleColorfulTitleWithSignupComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SimpleColorfulTitleWithSignupComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupForm = _props.signupForm, showDecorations = _props.showDecorations, showSignup = _props.showSignup, isFirstSegment = _props.isFirstSegment;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSimpleColorfulTitleWithSignupComponent, {
                    className: "simple-colorful-title-with-signup-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, {
                                title: title,
                                isFirstSegment: isFirstSegment
                            })
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "subtitle-wrapper",
                            children: typeof subtitle === "function" ? subtitle() : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                dangerouslySetInnerHTML: {
                                    __html: subtitle
                                }
                            })
                        }),
                        showSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-with-decorations-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread_props(_object_spread({}, signupForm), {
                                showDecorations: showDecorations
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return SimpleColorfulTitleWithSignupComponent;
}(react.PureComponent);

SimpleColorfulTitleWithSignupComponent.defaultProps = {
    title: "Start celebrating success. <brand-blue>Try for free</end>.",
    showSignup: true,
    isFirstSegment: false
};


/***/ }),

/***/ 31745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextAndAssetComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_paragraph_and_asset_columns_paragraph_and_asset_columns_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68137);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var TextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(TextAndAssetComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(TextAndAssetComponent);
    function TextAndAssetComponent(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, TextAndAssetComponent);
        return _super.call(this, props);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(TextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                var marginTop = this.props.marginTop;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "paragaph-and-asset-component",
                    style: {
                        marginTop: marginTop
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_paragraph_and_asset_columns_paragraph_and_asset_columns_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return TextAndAssetComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

TextAndAssetComponent.defaultProps = {
    content: {
        topic: {
            text: "Simple and intuitive",
            color: "brand-blue"
        },
        title: "Easy onboarding, fast adoption",
        body: [
            "Getting your team onboard recuires sending an invatation, and that’s it! It’s so visual and easy to use your teammates will get hooked immediatly."
        ],
        bottomLink: {
            href: "/",
            text: "See all features"
        }
    },
    asset: {
        side: "right",
        shadow: false
    }
};


/***/ }),

/***/ 44980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VideosGalleryComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/segments/videos-gallery/videos-gallery-component.scss.js

var StyledVideosGalleryComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh299ux0"
})("width:100vw;padding:48px 0;.videos-gallery-title{margin-bottom:32px;font-size:calc(1vw + 0.875rem);line-height:48px;text-align:center;b{font-weight:500;}}.videos-list-wrapper{max-width:900px;margin:auto;display:flex;flex-wrap:wrap;justify-content:space-between;}");

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/thumbnails/video-thumbnail-item/video-thumbnail-item-component.scss.js


var StyledVideoThumbnailItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lqb8yn0"
})("height:320px;width:280px;display:flex;flex-direction:column;margin-bottom:32px;border-radius:4px;box-shadow:0 2px 13px 0 rgba(206,206,206,0.5);cursor:pointer;transition:box-shadow 0.3s;.thumbnail-image-part{position:relative;height:200px;width:100%;.thumbnail-image{position:absolute;left:0;right:0;top:0;bottom:0;background-size:cover;background-position:center;transition:filter 0.3s;}.play-icon-container{position:absolute;bottom:12px;left:16px;svg{transition:transform 0.3s;}}}.thumbnail-text-part{flex:1;display:flex;flex-direction:column;justify-content:center;padding:0 16px;.video-title{font-size:1.375rem;line-height:32px;margin-bottom:8px;}.link-indicator{font-size:0.875rem;line-height:24px;text-decoration:underline;color:", colors/* default.brand-blue */.Z["brand-blue"], ";&:hover{color:", colors/* default.light-blue-hover */.Z["light-blue-hover"], ";}}}&:hover{box-shadow:0 10px 40px 0 rgba(192,192,192,0.4);.thumbnail-image-part{.thumbnail-image{filter:brightness(75%);}.play-icon-container{svg{transform:scale(1.1);}}}}");

;// CONCATENATED MODULE: ./static/svg/videos/video-play-button.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgVideoPlayButton = function SvgVideoPlayButton(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 70,
        height: 69,
        viewBox: "0 0 70 69"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#FFF",
        fillRule: "evenodd",
        d: "M34.85 68.789C15.927 68.789.586 53.469.586 34.572S15.926.356 34.851.356s34.266 15.319 34.266 34.216c0 18.898-15.342 34.217-34.266 34.217M27.873 46.03l20.01-9.991-20.01-9.99z"
    })));
};
/* harmony default export */ var video_play_button = (SvgVideoPlayButton);

// EXTERNAL MODULE: ./services/assets-service.js
var assets_service = __webpack_require__(57047);
;// CONCATENATED MODULE: ./components/core/thumbnails/video-thumbnail-item/video-thumbnail-item-component.js










var VideoThumbnailItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideoThumbnailItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideoThumbnailItemComponent);
    function VideoThumbnailItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VideoThumbnailItemComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(VideoThumbnailItemComponent, [
        {
            key: "onClick",
            value: function onClick() {
                var _props = this.props, index = _props.index, onClick1 = _props.onClick;
                onClick1(index);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, thumbnailSrc = _props.thumbnailSrc;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVideoThumbnailItemComponent, {
                    className: "video-thumbnail-item-component",
                    onClick: this.onClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "thumbnail-image-part",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "thumbnail-image",
                                    style: {
                                        backgroundImage: "url(".concat((0,assets_service/* getAssetPath */.K)(thumbnailSrc), ")")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "play-icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(video_play_button, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "thumbnail-text-part",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-title",
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "link-indicator",
                                    children: "Watch video"
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return VideoThumbnailItemComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/core/youtube-video-modal/youtube-video-modal-component.js + 7 modules
var youtube_video_modal_component = __webpack_require__(60202);
// EXTERNAL MODULE: ./constants/youtube-modal.js
var youtube_modal = __webpack_require__(29238);
;// CONCATENATED MODULE: ./components/segments/videos-gallery/videos-gallery-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var VideosGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VideosGalleryComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(VideosGalleryComponent);
    function VideosGalleryComponent(props) {
        (0,_class_call_check/* default */.Z)(this, VideosGalleryComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showVideo: false,
            activeVideoIndex: null
        };
        _this.onVideoThumbnailClick = _this.onVideoThumbnailClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onCloseVideoModal = _this.onCloseVideoModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderVideoItem = _this.renderVideoItem.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(VideosGalleryComponent, [
        {
            key: "onVideoThumbnailClick",
            value: function onVideoThumbnailClick(activeVideoIndex) {
                this.setState({
                    showVideo: true,
                    activeVideoIndex: activeVideoIndex
                });
            }
        },
        {
            key: "onCloseVideoModal",
            value: function onCloseVideoModal() {
                this.setState({
                    showVideo: false
                });
            }
        },
        {
            key: "getCurrentVideo",
            value: function getCurrentVideo() {
                var videos = this.props.videos;
                var activeVideoIndex = this.state.activeVideoIndex;
                return videos[activeVideoIndex];
            }
        },
        {
            key: "renderVideoItem",
            value: function renderVideoItem(video, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoThumbnailItemComponent, _object_spread_props(_object_spread({
                    index: index
                }, video), {
                    onClick: this.onVideoThumbnailClick
                }), index);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, videos = _props.videos;
                var showVideo = this.state.showVideo;
                var activeVideo = this.getCurrentVideo();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledVideosGalleryComponent, {
                    className: "videos-gallery-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "videos-gallery-title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "videos-list-wrapper",
                            children: videos.map(this.renderVideoItem)
                        }),
                        showVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_video_modal_component/* default */.Z, {
                            videoId: activeVideo.videoId,
                            footerText: activeVideo.videoFooterText,
                            minHeight: 546,
                            isOpen: true,
                            opts: youtube_modal/* VIDEO_OPTS */.C,
                            onCloseModal: this.onCloseVideoModal
                        })
                    ]
                });
            }
        }
    ]);
    return VideosGalleryComponent;
}(react.PureComponent);



/***/ }),

/***/ 73098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MobileContentComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js + 3 modules
var text_part_component = __webpack_require__(57858);
// EXTERNAL MODULE: ./services/assets-service.js
var assets_service = __webpack_require__(57047);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.scss.js


var StyledMobileContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e133280y0"
})("height:calc(100% - 54px);display:flex;flex-direction:column;align-items:center;justify-content:center;.image-part-wrapper{max-width:70vw;margin-bottom:30vh;img{width:100%;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.image-part-wrapper{max-width:80vw;}}@media (max-width:", vp_sizes/* XXS */.Mp - 1, "px){margin-bottom:30vh;.image-part-wrapper{display:none;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var MobileContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileContentComponent);
    function MobileContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileContentComponent, [
        {
            key: "getTextColor",
            value: function getTextColor() {
                var backgroundColor = this.props.imageWithBackgroundPart.backgroundColor;
                return backgroundColor === "transparent" || backgroundColor === "white" ? "black" : "white";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith, imageWithBackgroundPart = _props.imageWithBackgroundPart, isMobileOnly = _props.isMobileOnly;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileContentComponent, {
                    className: "mobile-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                customStyle: "mobile-clean-look",
                                color: "black",
                                isMobileCleanLook: true,
                                isMobileOnly: isMobileOnly
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            pictureClass: "image-part-wrapper",
                            src: (0,assets_service/* getAssetPath */.K)(imageWithBackgroundPart.src),
                            alt: imageWithBackgroundPart.alt
                        })
                    ]
                });
            }
        }
    ]);
    return MobileContentComponent;
}(react.PureComponent);

MobileContentComponent.defaultProps = {
    collaborationWith: {}
};


/***/ }),

/***/ 40119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnePagerWithImageContentComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js + 5 modules
var text_part_component = __webpack_require__(63126);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/decorators/background-triangle/background-triangle-component.scss.js



var StyledBackgroundTriangleComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e5hvm1d0"
})("position:absolute;border-bottom:100vh solid;border-left:18vw solid transparent;width:100%;top:0;right:0;&.straight-border{border-left:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){border-bottom:none;border-left:none;position:absolute;top:0;left:0;right:0;bottom:0;width:auto;z-index:", z_index/* HIDDEN */.A1, ";}");

;// CONCATENATED MODULE: ./components/enhancements/decorators/background-triangle/background-triangle-component.js









var BackgroundTriangleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BackgroundTriangleComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BackgroundTriangleComponent);
    function BackgroundTriangleComponent() {
        (0,_class_call_check/* default */.Z)(this, BackgroundTriangleComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BackgroundTriangleComponent, [
        {
            key: "getInlineStyles",
            value: function getInlineStyles(borderColor, gradientColor) {
                var styles = {};
                if (borderColor) {
                    styles.borderBottomColor = colors/* default */.Z[borderColor];
                }
                if (gradientColor) {
                    var bgColor = colors/* default */.Z[gradientColor];
                    var whiteColor = colors/* default.white */.Z.white;
                    styles.background = "linear-gradient(172deg, ".concat(bgColor, " 0%, ").concat(bgColor, " calc(100vh / 1.3), ").concat(whiteColor, " calc(100vh / 1.29), ").concat(whiteColor, ")");
                }
                return styles;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, borderColor = _props.borderColor, gradientColor = _props.gradientColor, straightBorder = _props.straightBorder;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBackgroundTriangleComponent, {
                    className: classnames_default()("background-triangle", {
                        "straight-border": straightBorder
                    }),
                    style: this.getInlineStyles(borderColor, gradientColor)
                });
            }
        }
    ]);
    return BackgroundTriangleComponent;
}(react.PureComponent);

BackgroundTriangleComponent.defaultProps = {
    straightBorder: false
};

// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./services/assets-service.js
var assets_service = __webpack_require__(57047);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/desktop-content/desktop-content-component.scss.js



var StyledDesktopContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yorqsd0"
})("height:calc(100vh - 65px);overflow:hidden;display:flex;align-items:center;.text-part-wrapper{width:45vw;display:flex;align-items:center;padding:16px 24px 16px 80px;}.image-wrapper{width:calc(100vw - 45vw);height:100%;display:flex;justify-content:flex-end;align-items:center;position:relative;.image-part-wrapper{width:45vw;display:flex;position:relative;padding:4vw 4vw;z-index:", z_index/* LAYER_ONE */.KW, ";align-items:center;justify-content:center;img{max-width:100%;max-height:80vh;}&.align-bottom{align-self:flex-end;}&.align-top{align-self:flex-start;}}}&.straight-border{.text-part-wrapper{width:50vw;}.image-wrapper{width:calc(100vw - 50vw);.image-part-wrapper{width:50vw;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-wrapper{padding:16px 0 16px 54px;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/desktop-content/desktop-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var DesktopContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DesktopContentComponent);
    function DesktopContentComponent() {
        (0,_class_call_check/* default */.Z)(this, DesktopContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DesktopContentComponent, [
        {
            key: "getSegmentHeight",
            value: function getSegmentHeight() {
                var imageWithBackgroundPart = this.props.imageWithBackgroundPart;
                return imageWithBackgroundPart.imageSegmentHeight || "100vh";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, collaborationWith = _props.collaborationWith, imageWithBackgroundPart = _props.imageWithBackgroundPart;
                signupForm.focusOnLoad = true;
                var alignText = imageWithBackgroundPart.imageAlign;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopContentComponent, {
                    className: classnames_default()("desktop-content-component", {
                        "straight-border": imageWithBackgroundPart.straightBorder
                    }),
                    style: {
                        height: "calc(".concat(this.getSegmentHeight(), " - 65px)")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "image-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundTriangleComponent, {
                                    borderColor: imageWithBackgroundPart.backgroundColor,
                                    straightBorder: imageWithBackgroundPart.straightBorder
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("image-part-wrapper", alignText),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                        src: (0,assets_service/* getAssetPath */.K)(imageWithBackgroundPart.src),
                                        alt: imageWithBackgroundPart.alt
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return DesktopContentComponent;
}(react.PureComponent);
/* harmony default export */ var desktop_content_component = ((0,ab_tests_context/* withAbTests */.k)(DesktopContentComponent));

// EXTERNAL MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/mobile-content/mobile-content-component.js + 1 modules
var mobile_content_component = __webpack_require__(73098);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component.scss.js



var StyledOnePagerWithImageContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yv1r0r0"
})("width:100vw;display:flex;justify-content:space-around;.desktop-content-wrapper{width:100%;}.mobile-content-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.desktop-content-wrapper{display:none;}.mobile-content-wrapper{display:flex;z-index:", z_index/* LAYER_ONE */.KW, ";justify-content:center;align-items:center;}}");

// EXTERNAL MODULE: ./components/segments/social-proof/social-proof-component.js + 1 modules
var social_proof_component = __webpack_require__(18925);
// EXTERNAL MODULE: ./components/segments/short-footer/short-footer-component.js
var short_footer_component = __webpack_require__(83234);
// EXTERNAL MODULE: ./components/segments/videos-gallery/videos-gallery-component.js + 4 modules
var videos_gallery_component = __webpack_require__(44980);
;// CONCATENATED MODULE: ./components/templates/one-pager-with-image-template/one-pager-with-image-content/one-pager-with-image-content-component.js




function one_pager_with_image_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_with_image_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_with_image_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}








var OnePagerWithImageContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerWithImageContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerWithImageContentComponent);
    function OnePagerWithImageContentComponent() {
        (0,_class_call_check/* default */.Z)(this, OnePagerWithImageContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerWithImageContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, videosGallery = _props.videosGallery, SocialProof = _props.SocialProof, ShortFooter = _props.ShortFooter;
                var showSocialProof = SocialProof.showSocialProof, socialProofContent = SocialProof.content;
                var showShortFooter = ShortFooter.showShortFooter, shortFooterContent = ShortFooter.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOnePagerWithImageContentComponent, {
                    className: "one-pager-with-image-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "desktop-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_content_component, one_pager_with_image_content_component_object_spread({}, this.props)),
                                showSocialProof && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, socialProofContent)),
                                showShortFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, shortFooterContent)),
                                videosGallery && /*#__PURE__*/ (0,jsx_runtime.jsx)(videos_gallery_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, videosGallery))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_content_component/* default */.Z, one_pager_with_image_content_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return OnePagerWithImageContentComponent;
}(react.PureComponent);

OnePagerWithImageContentComponent.defaultProps = {
    textPart: {},
    imageWithBackgroundPart: {},
    collaborationWith: {},
    SocialProof: {},
    ShortFooter: {}
};


/***/ }),

/***/ 57047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getAssetPath; }
/* harmony export */ });
/* harmony import */ var services_environment_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56274);
/* harmony import */ var services_environment_service__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(services_environment_service__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(83454);

var isStorybook = process.env.IS_STORYBOOK === "true";
var getStagingAssetPath = function(src) {
    return "https://mondaystaging.com" + src;
};
var isLocalAssetPath = function(src) {
    return (services_environment_service__WEBPACK_IMPORTED_MODULE_0__.isDevelopment || isStorybook) && src && src.startsWith("/static/");
};
var getAssetPath = function(src) {
    return isLocalAssetPath(src) ? getStagingAssetPath(src) : src;
};


/***/ }),

/***/ 84657:
/***/ (function(module) {


var convertToArrayIfNeeded = function(obj) {
    return Array.isArray(obj) ? obj : [
        obj
    ];
};
// Finds an empty cell index in the given array
var findEmptyIndex = function(arr) {
    if (arr) {
        for(var i = 0; i < arr.length; i++){
            if (!arr[i]) {
                return i;
            }
        }
        return arr.length;
    }
    return -1;
};
// returns a random value from the given array
var getRandomValue = function(arr) {
    var randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
};
// moves the given values to the beginning of the array
var moveToBeginningIfExists = function(arr, valuesToBeAtBeginning) {
    if (arr && valuesToBeAtBeginning) {
        for(var i = valuesToBeAtBeginning.length - 1; i >= 0; i--){
            var value = valuesToBeAtBeginning[i];
            var index = arr.indexOf(value);
            if (index > -1) {
                arrayMove(arr, index, 0);
            }
        }
    }
    return arr;
};
var arrayMove = function(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
};
var gettArrayWithIncrementingNumbers = function(size) {
    return Array.from(Array(size).keys());
};
module.exports = {
    convertToArrayIfNeeded: convertToArrayIfNeeded,
    findEmptyIndex: findEmptyIndex,
    getRandomValue: getRandomValue,
    moveToBeginningIfExists: moveToBeginningIfExists,
    arrayMove: arrayMove,
    gettArrayWithIncrementingNumbers: gettArrayWithIncrementingNumbers
};


/***/ })

}]);